export default "__VITE_ASSET__XE2TbjLccIt5As8HIB9R5A__"